export const resources = [
  {
    id: 'res-1',
    title: 'Unsplash',
    description: '全球最大的免费高清图片库，数百万张高质量图片可供免费下载使用，支持商业用途，无需署名。摄影师社区活跃，每日更新海量精美图片。',
    url: 'https://unsplash.com',
    categoryId: 'cat-2',
    tags: ['免费图库', '高清图片', '摄影'],
    isHot: true,
    isNew: false,
    icon: 'ri-image-2-line',
    createdAt: '2026-06-15',
  },
  {
    id: 'res-2',
    title: 'Figma',
    description: '领先的在线UI设计协作工具，免费版功能强大，支持实时协作、组件库、原型设计，是设计师和产品团队的必备工具。',
    url: 'https://www.figma.com',
    categoryId: 'cat-1',
    tags: ['UI设计', '原型设计', '协作工具'],
    isHot: true,
    isNew: false,
    icon: 'ri-pencil-ruler-2-line',
    createdAt: '2026-05-20',
  },
  {
    id: 'res-3',
    title: 'GitHub Copilot Free',
    description: 'GitHub推出的AI编程助手免费版，支持多种编程语言，可在VS Code等编辑器中使用，大幅提升编码效率。',
    url: 'https://github.com/features/copilot',
    categoryId: 'cat-9',
    tags: ['AI编程', '代码助手', '开发工具'],
    isHot: true,
    isNew: true,
    icon: 'ri-robot-2-line',
    createdAt: '2026-08-01',
  },
  {
    id: 'res-4',
    title: 'Canva',
    description: '在线平面设计平台，提供海量免费模板、图片、字体素材，无需设计基础即可快速制作海报、社交媒体图片等。',
    url: 'https://www.canva.com',
    categoryId: 'cat-1',
    tags: ['平面设计', '模板', '在线设计'],
    isHot: true,
    isNew: false,
    icon: 'ri-layout-5-line',
    createdAt: '2026-04-10',
  },
  {
    id: 'res-5',
    title: 'Remove.bg',
    description: '一键免费去除图片背景的在线工具，AI智能识别，处理速度快，效果出色，支持批量处理，非常适合电商和设计场景。',
    url: 'https://www.remove.bg',
    categoryId: 'cat-4',
    tags: ['抠图', '去背景', '图片处理'],
    isHot: true,
    isNew: false,
    icon: 'ri-scissors-cut-line',
    createdAt: '2026-03-18',
  },
  {
    id: 'res-6',
    title: 'Vercel',
    description: '免费前端部署平台，支持静态网站和Serverless函数，与GitHub无缝集成，自动部署，全球CDN加速，开发者首选。',
    url: 'https://vercel.com',
    categoryId: 'cat-10',
    tags: ['网站部署', 'CDN', '前端'],
    isHot: false,
    isNew: false,
    icon: 'ri-cloud-line',
    createdAt: '2026-02-25',
  },
  {
    id: 'res-7',
    title: 'Google Fonts',
    description: '谷歌免费字体库，收录上千款开源字体，支持中文、英文等多语言，可直接在网页中引用，设计师和开发者的字体宝库。',
    url: 'https://fonts.google.com',
    categoryId: 'cat-6',
    tags: ['免费字体', '网页字体', '开源'],
    isHot: false,
    isNew: false,
    icon: 'ri-font-size-2',
    createdAt: '2026-01-12',
  },
  {
    id: 'res-8',
    title: 'Notion',
    description: '全能型笔记与协作工具，免费版功能完善，支持文档、数据库、看板、日历等多种视图，团队协作和个人知识管理利器。',
    url: 'https://www.notion.so',
    categoryId: 'cat-7',
    tags: ['笔记', '知识管理', '协作'],
    isHot: true,
    isNew: false,
    icon: 'ri-sticky-note-line',
    createdAt: '2026-07-08',
  },
  {
    id: 'res-9',
    title: 'Coursera 免费课程',
    description: '全球顶尖大学的免费在线课程平台，涵盖计算机科学、商业、艺术等多个领域，可免费旁听大部分课程内容。',
    url: 'https://www.coursera.org',
    categoryId: 'cat-5',
    tags: ['在线课程', '大学课程', '自我提升'],
    isHot: false,
    isNew: false,
    icon: 'ri-graduation-cap-line',
    createdAt: '2026-06-30',
  },
  {
    id: 'res-10',
    title: 'TinyPNG',
    description: '智能PNG和JPEG图片压缩工具，免费在线使用，可大幅减小图片文件体积而不影响视觉质量，提升网页加载速度。',
    url: 'https://tinypng.com',
    categoryId: 'cat-4',
    tags: ['图片压缩', '性能优化', '在线工具'],
    isHot: false,
    isNew: false,
    icon: 'ri-fullscreen-exit-line',
    createdAt: '2026-05-05',
  },
  {
    id: 'res-11',
    title: 'ChatGPT',
    description: 'OpenAI推出的免费AI对话助手，能回答问题、撰写文章、编写代码、翻译语言等，是目前最强大的免费AI工具之一。',
    url: 'https://chat.openai.com',
    categoryId: 'cat-9',
    tags: ['AI对话', '人工智能', '写作助手'],
    isHot: true,
    isNew: false,
    icon: 'ri-chat-3-line',
    createdAt: '2026-08-05',
  },
  {
    id: 'res-12',
    title: 'Pexels',
    description: '免费素材图片和视频网站，所有内容均可免费使用，无需署名，支持中文搜索，提供高质量免版权图片和短视频素材。',
    url: 'https://www.pexels.com',
    categoryId: 'cat-2',
    tags: ['免费图片', '视频素材', '免版权'],
    isHot: false,
    isNew: false,
    icon: 'ri-camera-line',
    createdAt: '2026-04-22',
  },
  {
    id: 'res-13',
    title: 'DeepL 翻译',
    description: '以翻译质量著称的免费在线翻译工具，支持31种语言互译，翻译准确度高，语句流畅自然，支持文档全文翻译。',
    url: 'https://www.deepl.com',
    categoryId: 'cat-4',
    tags: ['翻译工具', '语言工具', 'AI翻译'],
    isHot: false,
    isNew: true,
    icon: 'ri-translate-2',
    createdAt: '2026-07-25',
  },
  {
    id: 'res-14',
    title: 'IconPark',
    description: '字节跳动开源的免费图标库，提供超过2400个高质量图标，支持四种风格，可在线调整颜色和大小，支持SVG和React组件。',
    url: 'https://iconpark.oceanengine.com',
    categoryId: 'cat-1',
    tags: ['图标库', '开源', 'SVG'],
    isHot: false,
    isNew: false,
    icon: 'ri-emotion-line',
    createdAt: '2026-03-08',
  },
  {
    id: 'res-15',
    title: 'MDN Web Docs',
    description: 'Mozilla维护的免费Web开发文档，涵盖HTML、CSS、JavaScript等前端技术的权威教程和参考文档，开发者必读资源。',
    url: 'https://developer.mozilla.org',
    categoryId: 'cat-5',
    tags: ['Web开发', '技术文档', '前端'],
    isHot: false,
    isNew: false,
    icon: 'ri-book-2-line',
    createdAt: '2026-02-14',
  },
  {
    id: 'res-16',
    title: 'Pixlr',
    description: '免费在线图片编辑器，功能类似Photoshop，支持图层、滤镜、调整等专业功能，无需安装，打开浏览器即可使用。',
    url: 'https://pixlr.com',
    categoryId: 'cat-4',
    tags: ['图片编辑', '在线PS', '图像处理'],
    isHot: false,
    isNew: false,
    icon: 'ri-edit-2-line',
    createdAt: '2026-06-01',
  },
  {
    id: 'res-17',
    title: 'V0.dev',
    description: 'Vercel推出的免费AI前端代码生成工具，通过文字描述即可生成React组件代码，极大提升前端开发效率。',
    url: 'https://v0.dev',
    categoryId: 'cat-9',
    tags: ['AI开发', '代码生成', 'React'],
    isHot: true,
    isNew: true,
    icon: 'ri-sparkling-line',
    createdAt: '2026-08-08',
  },
  {
    id: 'res-18',
    title: 'FreeCodeCamp',
    description: '完全免费的编程学习平台，提供交互式编程课程和项目实践，涵盖前端、后端、数据科学等方向，获得业界广泛认可。',
    url: 'https://www.freecodecamp.org',
    categoryId: 'cat-5',
    tags: ['编程学习', '免费课程', '证书'],
    isHot: false,
    isNew: false,
    icon: 'ri-terminal-box-line',
    createdAt: '2026-05-12',
  },
];

export const getResourcesByCategory = (categoryId: string) => {
  return resources.filter((r) => r.categoryId === categoryId);
};

export const getHotResources = () => {
  return resources.filter((r) => r.isHot);
};

export const getNewResources = () => {
  return resources.filter((r) => r.isNew);
};

export const getLatestResources = (limit: number = 8) => {
  return [...resources]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, limit);
};

export const getResourceById = (id: string) => {
  return resources.find((r) => r.id === id);
};